import { Slot } from '@radix-ui/react-slot';
import { cn } from '@repo/lib/cn';

import type { ElementLinkProps } from '.';

import { useScrollContext } from '.';

export function ElementLink<T extends string>(elementLinkProps: ElementLinkProps<T>) {
  const { to, className, style, activeClass = 'active', activeStyle, onClick, asChild = false, ...props } = elementLinkProps;

  const { scrollTo, isActive } = useScrollContext();
  const isCurrentActive: boolean = isActive(to);

  const handleClick = () => {
    onClick?.();
    setTimeout(() => {
      scrollTo(to);
    }, 100);
  };

  const Comp = asChild ? Slot : 'div';

  return (
    <Comp
      data-slot={'scroll-element-link-' + to}
      className={cn(className, isCurrentActive && activeClass)}
      style={isCurrentActive ? { ...style, ...activeStyle } : style}
      onClick={handleClick}
      {...props}
    />
  );
}
